import { DOT_COLORS } from 'cpool-constants';
import { SchemaLoanRequestResolver_Get, SchemaLoanRequestResolver_GetSummary } from 'cpool-tables/backend-resolvers';
import type { TFunction } from 'i18next';
import { LuUsersRound } from 'react-icons/lu';
import { LeadTraitInfo } from '~/types/LeadTraits';

export const getPartnerInfo = (
    lead: SchemaLoanRequestResolver_GetSummary[number] | SchemaLoanRequestResolver_Get,
    t: TFunction<'de' | 'en', undefined>,
): LeadTraitInfo =>
    lead.tracking?.directPartnerId || lead.tracking?.pid
        ? {
              dot: DOT_COLORS.YELLOW,
              Icon: LuUsersRound,
              text: t('LEADS.TRAIT.PARTNER_LEAD'),
          }
        : null;
